import { render } from "./CombinedContextMenu.vue?vue&type=template&id=4b7bd248&ts=true"
import script from "./CombinedContextMenu.vue?vue&type=script&lang=ts"
export * from "./CombinedContextMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__